/**
 * Builds the description for a Sacco deposit debit transaction.
 * Defaults to "Sacco deposit" when the note is absent or whitespace-only.
 */
export function buildDepositDescription(note: string | null | undefined): string {
  if (!note || note.trim().length === 0) return 'Sacco deposit';
  return note;
}
